import { render } from "./AccountWrapper.vue?vue&type=template&id=0d0fa118&scoped=true"
import script from "./AccountWrapper.vue?vue&type=script&lang=js"
export * from "./AccountWrapper.vue?vue&type=script&lang=js"

import "./AccountWrapper.vue?vue&type=style&index=0&id=0d0fa118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0fa118"]])

export default __exports__